import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver loop notifications from development overlay
if (typeof window !== "undefined") {
  const isResizeObserverError = (msg) =>
    typeof msg === "string" && msg.includes("ResizeObserver");

  window.addEventListener("error", (e) => {
    if (isResizeObserverError(e?.message) || isResizeObserverError(e?.error?.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });

  window.addEventListener("unhandledrejection", (e) => {
    if (isResizeObserverError(e?.reason?.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
